import React from 'react'
import MapFrame from "../../theme/maps/mapFrame";

export default class MapTest extends React.Component {

    render() {
        return (
            <div>
                <MapFrame/>
            </div>
        )
    }

}
